import {useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {BehaviorSubject} from 'rxjs';

interface InfoDialogProps {
    header?: string;
    width?: string;
    body?: any;
}

const props = new BehaviorSubject(null);
export const InfoDialogService = {
    getProps: () => props.asObservable(),
    show: (infoDialogProps: InfoDialogProps) => {
        props.next(infoDialogProps);
    }
};

export const AppInfoDialog = () => {

    const [display, setDisplay] = useState(false);
    const _props: InfoDialogProps = {};
    const [props, setProps] = useState(_props);

    useEffect(() => {
        InfoDialogService.getProps().subscribe((props) => {
            if (props) {
                setProps(props);
                setDisplay(true);
            }
        });
    }, []);

    return (
        <Dialog header={props.header} visible={display} style={{width: props.width}} onHide={() => setDisplay(false)}>
            {props.body}
            <div className="flex justify-content-end">
                <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm"/>
            </div>
        </Dialog>
    );
}
